import React, { useEffect, useRef } from 'react'
import { Marker } from 'react-leaflet';
import xcipioMarkerIcon from 'assets/topology/Xcipio_Marker.svg';
import ccpagMarkerIcon from 'assets/topology/ccpag.svg';
import mdf2MarkerIcon from 'assets/topology/mdf2.svg';
import mdf3MarkerIcon from 'assets/topology/mdf3.svg';
import admfMarkerIcon from 'assets/topology/admf.svg';
import './map.scss';

import L from 'leaflet';
import { renderToString } from 'react-dom/server';
import { CustomMarkerIcon } from './NetworkElement';
import 'leaflet-responsive-popup';
import 'leaflet-responsive-popup/leaflet.responsive.popup.css';
import { createNeRowItem, createRowHeader } from './utils/tooltipData';

type Props = {
  position: any,
  onClick?: (event: any) => void,
  data: any,
  details: any,
  onHover: any
};

export const getMarkerIconByType = (nodeType: string) => {
  switch (nodeType) {
    case 'ADMF': {
      return admfMarkerIcon;
    }
    case 'MDF2': {
      return mdf2MarkerIcon;
    }
    case 'MDF3': {
      return mdf3MarkerIcon;
    }
    case 'CCPAG': {
      return ccpagMarkerIcon;
    }
    default: {
      return xcipioMarkerIcon;
    }
  }
}

const XcipioMarker = ({
 position, data, details, onHover
}: Props) => {
  const trimmedText = data.nodeName.length > 12 ? `${data.nodeName.substring(0, 12)}...` : data.nodeName;
  const markerIcon = L.divIcon({
    html: renderToString(<CustomMarkerIcon text={trimmedText} icon={getMarkerIconByType(data.nodeType)} showLeaderAMDFBadge={data.status === 'LEADER'} />),
    className: 'ne-div-class',
    iconSize: [40, 40],
  });
  const markerRef = useRef<L.Marker>(null);
  useEffect(() => {
    if (markerRef && markerRef.current) {
      const marker = markerRef.current as L.Marker;
      const popup = L.responsivePopup({ offset: [20, 20] }).setContent(renderPopup(data, details.location));
      marker.bindPopup(popup);
    }
  }, [markerRef])

  const renderPopup = (xcipioNode: any, location: any): HTMLDivElement => {
    const {
      id,
      nodeName,
      nodeType,
      topology,
      ipAddress
    } = xcipioNode;
    const popupNe = L.DomUtil.create('div', 'popup-ne');
    const popupContainerNe = L.DomUtil.create('div', 'popup-container-ne', popupNe);
    if (nodeName) {
      createRowHeader(popupContainerNe, xcipioNode, nodeName);
    }
    if (location.city && location.stateCode) {
      createNeRowItem(popupContainerNe, 'Location: ', `${location.city}, ${location.stateCode}.`);
    }
    if (ipAddress) {
      createNeRowItem(popupContainerNe, 'IP Address: ', ipAddress);
    }
    return popupNe;
  };
  const onClick = (event: any) => {
    const clickedElement = event.originalEvent.target;
    if (markerRef && markerRef.current) {
      const marker = markerRef.current as L.Marker;
      if (clickedElement.tagName !== 'IMG') {
        /*
        In useEffect hook, when bindPopup is called Leaflet automatically associates its own default callback for opening and closing popup.
        The custom onClick callback defined here is executed prior to Leaflet's default callback. Specifically, when a user clicks on the popup trigger:
        1. Our custom onClick callback is invoked to open the popup.
        2. Immediately after, Leaflet's default callback is triggered and closes the popup.
        */
        marker.openPopup();
      }
    }
  }
  return (
    <Marker position={position} data-original={details} icon={markerIcon} eventHandlers={{ mouseover: onHover, click: onClick }} ref={markerRef} />
  )
}

export default XcipioMarker;
